import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { getDataFromLocalStorage } from "../util/localStorage";
import { generateResponse, fetchChatHistory } from "../util/chatUtils";
import sendButton from "../images/sendButton.png";
import uploadIcon from "../images/uploadIconWhite.svg";
import ErrorPopUpComponent from "./ErrorPopUpComponent";
import fullscreen from "../images/fullscreen.svg";
import exitFullScreenIcon from "../images/exitFullScreenIcon.svg";

const ChatComponent = ({ onToggleFullScreen, fullscreenPanel }) => {
  const [query, setQuery] = useState("");
  const [chatHistory, setChatHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [openDocument, setOpenDocument] = useState(null);
  const chatContainerRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isMessageShow, setIsMessageShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const handleQueryChange = (e) => setQuery(e.target.value);

  useEffect(() => {
    const data = getDataFromLocalStorage("documentList");
    if (data && Array.isArray(data)) {
      const fileName = data.find((item) => item.id == id);
      if (fileName) {
        // console.log("data", data, fileName);
        setFileName(fileName.doc_name); // Set the file name
      }
    }
  }, []);

  useEffect(() => {
    const getChatHistory = async () => {
      const history = await fetchChatHistory(
        id,
        setErrorMessage,
        setIsMessageShow
      ); // Use the utility function here
      if (history) {
        setChatHistory(history);
      }
    };
    getChatHistory();
  }, [id]);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };

  const handleGenerateResponse = () => {
    generateResponse({
      id,
      query,
      // openDocument,
      setChatHistory,
      scrollToBottom,
      setLoading,
      setErrorMessage,
      setIsMessageShow,
    });
    setQuery(""); // Clear the input
  };

  return (
    <div className="sm:w-[100%] chatComponent w-[100%] min-h-[calc(100vh-70px)]] relative pt-[60px]">
      <div className="absolute w-full flex sm:justify-end justify-start top-0 bg-[#323639]">
        <button
          className="absolute fullScreenIcon left-[14px] top-[20px] rounded"
          onClick={onToggleFullScreen}
          title="View full screen"
        >
          {fullscreenPanel === "chat" ? (
            <img
              alt="Full Screen"
              src={exitFullScreenIcon}
              className="w-[20px]"
            />
          ) : (
            <img alt="Full Screen" src={fullscreen} className="w-[13px]" />
          )}
        </button>
        <span className="mt-[14px] mb-[14px] pr-2 truncate block w-[99%] text-[18px] items-center justify-center text-[#f1f1f1] hover:text-[#fff] px-2 text-left sm:text-right">
          {fileName}
        </span>
      </div>
      <div
        id="result"
        ref={chatContainerRef}
        className="py-4 bg-white rounded overflow-y-auto chatRightCol h-[calc(100vh-150px)]"
      >
        {chatHistory.map((chat, index) => (
          <div key={index} className="mb-4">
            <p className="font-bold bg-[#faf9f6] py-[20px] px-[30px]">
              Q: {chat.question}
            </p>
            {chat.response ? (
              <div
                className="text-gray-800 px-[30px] py-[20px] pb-[40px]"
                dangerouslySetInnerHTML={{ __html: chat.response }}
              />
            ) : (
              chat.isLoading && (
                <div class="gemini-loader">
                  <div class="row"></div>
                  <div class="row"></div>
                </div>
              )
            )}
          </div>
        ))}
      </div>

      <div className="absolute chatInputCol bottom-0 p-4 left-0 w-full flex bg-[#fff]">
        <input
          type="text"
          value={query}
          onChange={handleQueryChange}
          placeholder="Enter query"
          className="border rounded p-2 w-full "
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleGenerateResponse();
            }
          }}
        />
        <button
          onClick={handleGenerateResponse}
          disabled={!query.trim()} // Disable if input is empty
          className={`text-white px-2 py-0 ml-2 rounded ${
            query.trim()
              ? "bg-#f1f1f1 hover:bg-[#ccc] cursor-pointer"
              : "bg-gray-300 cursor-not-allowed"
          }`}
        >
          <img src={sendButton} alt="Send" />
        </button>
      </div>
      <ErrorPopUpComponent
        isErrorShow={isMessageShow}
        errorMessage={errorMessage}
        redirect=""
      />
    </div>
  );
};

export default ChatComponent;
